<div
  *ngIf="showToast"
  class="et-toast"
  [class.is-ready]="uiIsReady"
  [class.is-exporting]="!uiIsReady"
  (click)="onToastClick()"
>
  <div class="et-bar">
    <span class="et-bar-fill" [style.width.%]="displayProgress"></span>
  </div>

  <div class="et-row">
    <div class="et-icon">
      <span *ngIf="!uiIsReady" class="et-pulse-ring" aria-hidden="true"></span>

      <svg *ngIf="!uiIsReady" class="et-icon-dl" width="18" height="18" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.25"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>

      <svg *ngIf="uiIsReady" class="et-icon-check" width="20" height="20" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.25"
           stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="m9 12 2 2 4-4"/>
      </svg>
    </div>

    <div class="et-content">
      <div class="et-content-top">
        <div class="et-title">
          <span>{{ titleText }}</span>
          <span *ngIf="showActiveCountBadge" class="et-count-badge">{{ activeCount }}</span>
        </div>
        <span class="et-percent">{{ displayProgress }}%</span>
      </div>
      <div class="et-subtitle">
        <span>{{ subtitleText }}</span>
      </div>
    </div>

    <button class="et-close-btn" type="button" aria-label="Dismiss" (click)="onDismiss($event)">
      <svg width="14" height="14" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.25"
           stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>
</div>